import { createContext } from "react";

const OrgThemeAccessContext = createContext({});

export default OrgThemeAccessContext;
